import React from 'react';
import { formatWithCommas } from '@perch-labs/warbler';
import { copyFor } from 'config';
import { MultipartDescription } from 'components/multipart-description';
import TreeIcon from '/images/icons/tree.svg';
import HomeIcon from '/images/icons/home.svg';
import WindmillIcon from '/images/icons/windmill.svg';
import { Container } from 'styles';
import { StatNumber, UnitTime } from './stats.style';

const getCopy = copyFor('usage.windDetails.stats');

interface Props {
  CO2?: number;
  homes?: number;
  kWh?: number;
}

export const Stats = ({ CO2, kWh, homes }: Props) => {
  const getDescription = (stat, copy) => (
    <Container
      textAlign="center"
      alignItems="baseline"
      small={{ textAlign: 'left' }}
    >
      <StatNumber>{formatWithCommas(stat)}</StatNumber>
      <UnitTime>{getCopy(copy)}</UnitTime>
    </Container>
  );

  const parts = [
    { description: getDescription(CO2, 'CO2'), icon: TreeIcon, id: 'CO2' },
    { description: getDescription(kWh, 'kWh'), icon: WindmillIcon, id: 'kWh' },
    {
      description: getDescription(homes, 'homes'),
      icon: HomeIcon,
      id: 'homes',
    },
  ];

  return (
    <MultipartDescription
      parts={parts}
      margin={{ bottom: '32px', top: '32px' }}
    />
  );
};
